import { render, staticRenderFns } from "./AwardManager.vue?vue&type=template&id=7ba81016&scoped=true&"
import script from "./AwardManager.vue?vue&type=script&lang=ts&"
export * from "./AwardManager.vue?vue&type=script&lang=ts&"
import style0 from "./AwardManager.vue?vue&type=style&index=0&id=7ba81016&scoped=true&lang=scss&"
import style1 from "./AwardManager.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba81016",
  null
  
)

export default component.exports